const getters = {
  // roles: state => state.user.roles,

}
export default getters
